import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetOrdersQuery } from "slices/common/orderSlice";
import AddTrack from "./addTrack";
import { IMAGE_URL } from "network";
import User from "../../../utility/user";

function Orders() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [openUser, setOpenUser] = useState(null);
  const [view, setView] = useState(false);
  const [type, setType] = useState("");

  const { data, isLoading, refetch } = useGetOrdersQuery({
    page,
    limit,
    search,
    orderType: "e-commerce",
  });

  const handleViewUserDetails = (data, type) => {
    setOpenUser(data);
    setType(type);
    setView(true);
  };
  const col = [
    {
      display: "Order Id",
      key: "cat",
      type: "display",
      render: (row) => <>{row._id || "-"}</>,
    },
    {
      display: "Items",
      key: "items",
      type: "display",
      render: (row) => (
        <div className="space-y-1">
          {row?.items?.length > 0 ? (
            row.items.map((item, index) => (
              <div
                key={index}
                className="bg-gray-100 px-3 py-1 rounded text-sm text-gray-800"
              >
                {item.itemRef?.name || "Unnamed"} × {item.quantity}
              </div>
            ))
          ) : (
            <div className="text-sm text-gray-400 italic">No items found</div>
          )}
        </div>
      ),
    },
    {
      display: "User",
      key: "userAction",
      type: "display",
      render: (row) => {
        const user = row?.user;
        if (!user) return <span className="text-gray-400 italic">No user</span>;
        return (
          <div className="flex items-center space-x-3">
            <img
              height={"100px"}
              width={"100px"}
              src={IMAGE_URL + user.image}
              alt={user.name}
              className="w-12 h-12 rounded-full object-cover border border-gray-300 shadow"
              crossOrigin="anonymous"
            />
            <div className="flex flex-col user-title">
              <span className="text-sm font-medium text-gray-800">
                {user.name}
              </span>
              <a
                className="text-xs text-blue-600 hover:underline"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewUserDetails(user, "user");
                }}
              >
                View Details
              </a>
            </div>
          </div>
        );
      },
    },
    { display: "Base Amount (₹)", key: "totalAmount", type: "display" },
    { display: "Discount (₹)", key: "discount", type: "display" },
    { display: "Coupon Discount (₹)", key: "couponDiscount", type: "display" },
    { display: "Tax (₹)", key: "tax", type: "display" },
    {
      display: "Delivery Charges (₹)",
      key: "deliveryCharges",
      type: "display",
    },
    { display: "Total Amount (₹)", key: "grandTotal", type: "display" },
    {
      display: "Payment Method",
      key: "paymentMethod",
      type: "display",
      render: (row) => row.paymentMethod?.toUpperCase() || "-",
    },
    { display: "Status", key: "orderStatus", type: "display" },
    { display: "Payment", key: "paymentStatus", type: "display" },
    {
      display: "Track Order Number",
      key: "track",
      type: "action",
      render: (row, clickModal) => (
        <>
          <Button onClick={() => clickModal(row)}>Add+</Button>
        </>
      ),
    },
  ];

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const clickModal = (row) => {
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this order?")) {
      //   await del(id).unwrap();
      //   refetch();
    }
  };

  const handleSubmit = () => {
    alert("Tracking Number Added Successfully");
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const closeView = () => {
    setOpenUser(null);
    setType(null);
    setView(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <User
        data={openUser}
        type={type}
        open={view}
        onClose={() => closeView()}
      />

      <AddTrack
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      {/* <Button onClick={handleAdd} style={{ background: "#fff" }}>
        Add Timeslot
      </Button> */}

      <Tables
        title={"Orders"}
        handleSearch={handleSearchChange}
        totalPages={data?.pagination?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        clickModal={clickModal}
        // handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
